export const COMMUNITY_POSTS_QUERY = '/communities/posts';
export const COMMUNITY_SUPPLIER_POSTS_QUERY = '/suppliers/community-relevant-posts';
export const COMMUNITY_POST_ASSOCIATED_SUPPLIER_QUERY = '/communities/posts/supplier';
